// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"my-z","breadcrumbForward":"ny-z","breadcrumbBack":"oy-z","selected":"py-z"};